const next = document.getElementById('slide_map_next');
const prev = document.getElementById('slide_map_prev');
const map1 = document.querySelector('.overlay1');
const map2 = document.querySelector('.overlay2');
console.log(map1);
let i = 0;

next.addEventListener('click',nextAnim);

function nextAnim(){
  if(i == 1){ return; }
  let carrousel = document.getElementById('container_carte');
  carrousel.classList.add("container_carte_anim_next");
  map1.classList.add("container_carte_anim_next");
  map2.classList.add("overlay_carte_anim_next");
  carrousel.style.marginLeft = "-100%";
  map1.style.marginLeft = "-100%";
  map2.style.marginLeft = "0%";
  i++;
  setTimeout(()=>{ 
     carrousel.classList.remove("container_carte_anim_next");  
     map1.classList.remove("container_carte_anim_next");
     map2.classList.remove("overlay_carte_anim_next");
  }, 600);
}

prev.addEventListener('click',prevAnim);

function prevAnim(){
  if(i == 0){ return; }
  let carrousel = document.getElementById('container_carte');
  carrousel.classList.add("container_carte_anim_prev");
  map1.classList.add("container_carte_anim_prev");
  map2.classList.add("overlay_carte_anim_prev");
  carrousel.style.marginLeft = "0%";
  map1.style.marginLeft = "0%";
  map2.style.marginLeft = "100%";
  i--;
  setTimeout(()=>{ 
     carrousel.classList.remove("container_carte_anim_prev");  
     map1.classList.remove("container_carte_anim_prev"); 
     map2.classList.remove("overlay_carte_anim_prev"); 
  }, 600);
}
